// Func = limiting Scope for this file
var lastScrollTop = 0;
//resize sizes
var w = window,
	d = document,
	e = d.documentElement,
	g = d.getElementsByTagName('body')[0],
	windowWidth = w.innerWidth || e.clientWidth || g.clientWidth,
	windowHeight = w.innerHeight || e.clientHeight || g.clientHeight;
resizeWindow();

(function () {
	if (document.getElementById('burgerMenu')) {
		document.getElementById('burgerMenu').addEventListener('click', function () {
			if (!this.classList.contains('open')) {
				this.classList.add('open');
				document.getElementById('primary-nav').classList.add('open');
				setTimeout(() => {
					document.getElementById('secondary-nav').classList.add('open');
				}, 500);
			} else {
				this.classList.remove('open');
				document.getElementById('primary-nav').classList.remove('open');
				document.getElementById('secondary-nav').classList.remove('open');
			}
		});
	}
	if (document.getElementById('attractions')) {
		if (document.getElementById('expand--attractions-map')) {
			document.getElementById('expand--attractions-map').setAttribute('aria-label', 'Expand map');
			document.getElementById('expand--attractions-map').addEventListener('click', function () {
				document.getElementById('expand--attractions-map').setAttribute('aria-label', 'minimize map');
				if (!document.getElementsByClassName('attraction-content')[0].classList.contains('map-expanded')) {
					document.getElementsByClassName('attraction-content')[0].classList.add('map-expanded');
					this.getElementsByTagName('span')[0].innerHTML = 'Minimize Map';
				} else {
					document.getElementsByClassName('attraction-content')[0].classList.remove('map-expanded');
					document.getElementById('expand--attractions-map').setAttribute('aria-label', 'enlarge map');
					this.getElementsByTagName('span')[0].innerHTML = 'Expand Map';
				}
			});
		}
		setTimeout(function () {
			//wrap around all btn texts
			if (document.getElementsByClassName('btn').length > 0) {
				let allBtn = document.getElementsByClassName('btn');
				let allBtnLength = allBtn.length;
				for (let i = 0; i < allBtnLength; i++) {
					let eachBtn = allBtn[i].innerHTML;
					allBtn[i].innerHTML = '<span>' + eachBtn + '</span>';
				}
			}
		}, 1000);
	}

	$(document).ready(function () {
		//ew jquery

		//booking form submit
		/* jQuery('#booking-form').submit(function(event) {
			event.preventDefault();
			var clientId;
			var checkIn = jQuery(this).find('[name="booking-checkin"]');
			var checkOut = jQuery(this).find('[name="booking-checkout"]');
			var checkInVal = checkIn.val();
			var checkOutVal = checkOut.val();
			var checkInArray = checkInVal.split('/');
			var checkOutArray = checkOutVal.split('/');
			var checkInYear = checkInArray[2];
			var checkInMonth = parseInt(checkInArray[0]) - 1;
			var checkInMonthAdj = checkInArray[0];
			var checkInDay = checkInArray[1];
			var checkOutYear = checkOutArray[2];
			var checkOutMonth = parseInt(checkOutArray[0]) - 1;
			var checkOutDay = checkOutArray[1];
			var numbadult = jQuery(this).find('[name=adults]').val();
			var numbchild = jQuery(this).find('[name=child]').val();
			//calculate number of days chosen
			var oneDay = 24*60*60*1000; // hours*minutes*seconds*milliseconds
			var checkInDate = new Date(checkInYear,checkInMonth,checkInDay);
			var checkOutDate = new Date(checkOutYear,checkOutMonth,checkOutDay);		
			var numDays = Math.round(Math.abs((checkInDate.getTime() - checkOutDate.getTime())/(oneDay)));
			//validation
			if (checkInDate >= checkOutDate) {
				alert('Your Check-out day must be after your Check-in day. Please check your selection and try again.');
				return false;
			}	

			//go to booking URL
			if(is_live) {
				ga(function(tracker) {
					clientId = tracker.get('linkerParam');
				});
			}
			
			
			var bookingURL = 'https://www.bookonthenet.net/east/premium/eresmain.aspx?id=61FLf349A8WlagIVA2CFApP0vWq6O5owg6u81DRt6Jo%3d&arrival_date='+ checkInMonthAdj +'%2F'+ checkInDay +'%2F'+ checkInYear +'&stay_nights='+ numDays +'&adults=' + numbadult +'&children='+ numbchild +'&' + clientId;
			window.open(bookingURL,'_blank'); 
		}); */

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date) {
			let d1 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckIn').val());
			let d2 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckOut').val());
			if ((d1 && date.getTime() == d1.getTime()) || (d2 && date.getTime() == d2.getTime())) {
				DATE_STYLE[1] = 'highlight-top';
			} else if (date > d1 && date < d2) {
				DATE_STYLE[1] = 'highlight';
			} else {
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = $('#CheckIn').data('format') !== undefined && $('#CheckIn').data('format') ? $('#CheckIn').data('format') : 'yy-mm-dd';
		$('#CheckIn').datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			dateFormat: DATE_FORMAT,
			numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function (selectedDate) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$('#CheckOut').datepicker('setDate', newDate);
				$('#CheckOut').datepicker('option', 'minDate', selectedDate);
			},
		});

		$('#CheckOut').datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			dateFormat: DATE_FORMAT,
			changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function (selectedDate) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			},
		});
	});

	window.onload = function () {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function () {
			scrollW();
		});

		//resizeWindow();
		window.addEventListener('resize', function () {
			resizeWindow();
		});
	};

	const pins = document.querySelectorAll('.pin');
    const pinContents = document.querySelectorAll('.pin-content__item');

    // Agrega el evento click a cada pin
    pins.forEach(pin => {
        pin.addEventListener('click', (event) => {
            // Evita que el evento se propague al documento
            event.stopPropagation();

            // Obtén el data-id del pin clickeado
            const dataId = pin.getAttribute('data-id');

            // Cierra cualquier pin-content abierto
            pinContents.forEach(content => content.classList.remove('open'));

            // Busca el pin-content correspondiente y agrega la clase .open
            const targetContent = document.querySelector(`.pin-content__item[data-id="${dataId}"]`);
            if (targetContent) {
                targetContent.classList.add('open');
            }
        });
    });

    // Agrega un evento click al documento para cerrar los pin-content
    document.addEventListener('click', () => {
        pinContents.forEach(content => content.classList.remove('open'));
    });
})();

function scrollW() {
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if (st > 80) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

function resizeWindow() {
	//calculate a new window size
	windowWidth = w.innerWidth || e.clientWidth || g.clientWidth;
	windowHeight = w.innerHeight || e.clientHeight || g.clientHeight;
}
